import React from "react";

import { Icon } from "widgets";

import { UPLOAD_ICONS } from "../constants/uploadsContent";
import styles from "../containers/Uploads/UploadsContainer.module.scss";

const UploadInfoBanner = ({ message }) => (
  <div className={styles.infoBannerSlot}>
    <div className={styles.infoBanner}>
      <Icon name={UPLOAD_ICONS.INFO} className={styles.infoIcon} />
      <span>{message}</span>
    </div>
  </div>
);

export default UploadInfoBanner;
